// extracted by mini-css-extract-plugin
export default {"icon--medium":"iDM_Hxy","icon--small":"W3gD457"};